/* eslint-disable max-lines */
import clsx from 'clsx';
import React, { useContext, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { getNamespace } from '../../../utils/storage';
import { getForms, getFormStructure } from '../../../redux/DynamicForms/DynamicFormsAction';
import { useDispatch, useSelector } from 'react-redux';
import MessagesContext from '../../../contexts/messagesContext';
import { CircularProgress, makeStyles } from '@material-ui/core';
import SelectionForm from './SelectionForm';
import FieldValue from './FieldValue';
import { CloseIcon } from '../../UI/Images/Icons';
// import AndOrButton from './AndOrButton';
import {
    deleteSelectedField,
    addStructure,
    addField,
    deleteField,
    deleteValue
} from '../../../redux/Search/SearchAction';
import usePatientFields from './PatientFields';
import { useUserClinics } from '../../../hooks/useUserClinics';

const styles = makeStyles({
    selectWrapper: {
        width: '210px',
        marginInlineEnd: '8px'
    },
    row: {
        display: 'flex',
        alignItems: 'flex-end'
    },
    delIcon: {
        marginBottom: '8px',
        cursor: 'pointer'
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '200px',
        height: '38px',
        alignItems: 'center'
    },
    selectClinic: {
        marginBottom: '10px'
    },
    errorMessage: {
        color: 'red',
        margin: '5px 0 ',
        visibility: ({ isInvalid }) => (isInvalid ? 'visible' : 'hidden')
    }
});
const SearchField = ({ item, length, handleSelectClinic, isInvalid }) => {
    const { index } = item;
    const dispatch = useDispatch();
    const classes = styles({ isInvalid });
    const { messages } = useContext(MessagesContext);
    const allForms = useSelector((state) => state.dynamicForms.allForms);
    const firstIndex = index === 1;
    const [formsOption, setFormsOption] = useState([]);
    const [fieldsOption, setFieldsOption] = useState([]);
    const [field, setField] = useState({});
    const [formName, setFormName] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const patientFields = usePatientFields();
    const options = useUserClinics();

    const resetField = () => {
        setField({
            value: { id: null, name: null },
            dataType: null,
            metaData: null
        });
    };

    useEffect(() => {
        const namespace = getNamespace();
        if (namespace) {
            dispatch(getForms(namespace));
        }
    }, []);
    useEffect(() => {
        if (allForms?.length) {
            const patientForm = [{ id: 'patient', name: messages.patientInfo }];
            setFormsOption([
                ...patientForm,
                ...allForms?.map((item) => ({ id: item.name, name: item.title }))
            ]);
        }
    }, [allForms]);
    useEffect(() => {
        // const modifiedType = {
        //     id: 'modified',
        //     name: 'modified_date',
        //     data_type: 'date',
        //     metadata: {}
        // };

        const isPatient = formName === 'patient';
        if (isPatient) {
            setFieldsOption([...patientFields.fields]);
            if (formName) {
                resetField();
            }
        } else {
            const fetch = async () => {
                setIsLoading(true);
                const response = await dispatch(getFormStructure(formName));
                setIsLoading(false);
                if (!response?.data?.fields?.length) {
                    setFieldsOption([]);
                } else {
                    setFieldsOption(
                        response.data.fields
                            ?.filter(
                                (item) =>
                                    item.data_type !== 'file' &&
                                    item.data_type !== 'none' &&
                                    item.data_type !== 'group' &&
                                    !item?.hidden &&
                                    !item.presentation.invisible &&
                                    item.label
                            )
                            ?.sort((a, b) => a.order - b.order)
                            ?.map((form) => ({
                                id: form.name,
                                name: form.label,
                                data_type: form.data_type,
                                metadata: form.metadata
                            }))
                    );
                }
            };
            if (formName) {
                fetch();
                resetField();
            }
        }
    }, [formName]);
    const handleSelectForm = (val) => {
        const name = val?.id;
        const existValue = item.value;
        const existField = item?.field?.id;
        const isPatient = name === 'patient';

        if (name) {
            setFormName(name);
            const findForm = allForms.find((item) => item.name === name);
            dispatch(
                addStructure({
                    index: index,
                    // title: findForm.title,
                    id: isPatient ? name : findForm.name
                })
            );
            if (existField) {
                dispatch(deleteSelectedField(index));
            }
            if (existValue) {
                dispatch(deleteValue(index));
            }
        } else {
            setFormName(null);
            dispatch(deleteField(index));
        }
    };
    const handleSelectField = (val) => {
        const id = val?.id;
        const findField = fieldsOption.find((item) => item.id === id);
        const existValue = item.value;

        if (id) {
            if (existValue) {
                dispatch(deleteValue(index));
            }
            dispatch(
                addField({
                    index: index,
                    id: findField?.id,
                    name: findField?.name
                })
            );

            if (findField?.data_type) {
                setField({
                    value: { id: findField?.id, name: findField?.name },
                    dataType: findField?.data_type,
                    metaData: findField?.metadata
                });
            } else {
                setField({
                    value: null,
                    dataType: null,
                    metaData: null
                });
            }
        } else {
            dispatch(deleteSelectedField(index));
            dispatch(deleteValue(index));

            setField({
                value: null,
                dataType: null,
                metaData: null
            });
        }
    };
    const handleDelete = () => {
        dispatch(deleteField(index));
    };

    return (
        <>
            <div className={clsx(classes.selectWrapper, classes.selectClinic)}>
                <SelectionForm
                    name="clinics"
                    options={options}
                    label={messages.exportFromClinics}
                    placeholder="select clinics..."
                    handleChange={handleSelectClinic}
                />
                <span className={classes.errorMessage}>{messages.validations.required}</span>{' '}
            </div>
            <div className={classes.row}>
                <div className={classes.selectWrapper}>
                    <SelectionForm
                        name="form"
                        options={formsOption}
                        label={firstIndex && messages.formName}
                        handleChange={handleSelectForm}
                        index={index}
                        placeholder="select form"
                    />
                </div>
                {isLoading && !fieldsOption.length && (
                    <div className={classes.loadingContainer}>
                        <CircularProgress size={30} />
                    </div>
                )}
                {!!formName && fieldsOption.length ? (
                    <div className={classes.selectWrapper}>
                        <SelectionForm
                            name="field"
                            options={isLoading ? [] : fieldsOption}
                            loading={isLoading}
                            label={firstIndex && messages.fieldName}
                            value={field?.value}
                            handleChange={handleSelectField}
                            index={index}
                            placeholder="select field"
                        />
                    </div>
                ) : null}
                {!!formName && field?.dataType && (
                    <>
                        <FieldValue
                            field={field}
                            firstIndex={firstIndex}
                            formName={formName}
                            item={item}
                        />
                        {/* {fieldsDetail.length > 1 && field?.dataType && <AndOrButton />} */}
                    </>
                )}
                {length > 1 && <CloseIcon onClick={handleDelete} className={classes.delIcon} />}
            </div>
        </>
    );
};
SearchField.propTypes = {
    item: PropTypes.object,
    index: PropTypes.number,
    length: PropTypes.number,
    isInvalid: PropTypes.bool,
    handleSelectClinic: PropTypes.function
};
export default React.memo(SearchField);
